function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15mm",
    height: "15mm",
    viewBox: "0 0 15 15",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      strokeWidth: 0.278672
    },
    d: "M 0.20397616,14.900335 C 0.09179616,14.777725 6.1560868e-6,11.490795 6.1560868e-6,7.5960449 c 0,-6.99068204 0.00700000391,-7.08562304 0.5946900039132,-7.41554004 0.58193004,-0.32702 6.30230004,-0.195117 12.05103984,0.277877 l 2.1756,0.179004 0.13631,6.42509904 c 0.0749,3.5337901 0.0478,6.6348601 -0.0604,6.8912401 -0.10822,0.25639 -0.59788,0.54804 -1.08814,0.6481 -1.39557,0.28485 -13.37707984,0.54774 -13.60508984,0.29851 z M 11.666316,13.621265 c 1.25621,-0.14639 2.29642,-0.30059 2.31159,-0.3427 0.0152,-0.0421 -0.008,-2.65803 -0.0511,-5.8131601 l -0.0786,-5.736623 -3.32076,-0.334796 C 8.7010262,1.2098479 5.8299362,1.0606599 4.1472462,1.0624579 l -3.05946,0.0032 v 6.523777 6.5237801 l 4.14726,-0.11294 c 2.28098,-0.0621 5.1750498,-0.2327 6.4312498,-0.37909 z m -5.5044398,-1.61156 c -0.0985,-0.10329 -0.17895,-0.80045 -0.17895,-1.54914 0,-1.2727101 -0.0486,-1.3671101 -0.74786,-1.4515901 -0.99366,-0.12006 -0.99366,-0.91734 0,-1.03739 l 0.74786,-0.0903 v -2.53067 c 0,-2.549548 0.30495,-3.428148 1.18985,-3.428148 0.49413,0 2.07356,1.804822 2.07356,2.369462 0,0.737686 -0.46495,0.586096 -1.35561,-0.441934 l -0.80405,-0.928069 -0.008,2.482229 -0.008,2.48223 1.15579,0.0879 c 0.80889,0.0614 1.15579,0.21636 1.15579,0.51614 0,0.29979 -0.3469,0.45471 -1.15579,0.51616 l -1.15579,0.0879 v 1.2336401 c 0,1.15984 -0.509,2.10172 -0.90887,1.68184 z",
    id: "path1773"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a349ebeaeca3c0b4c95ce3a78dc8780c.svg";
export { ForwardRef as ReactComponent };